import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { AppConfig } from "../../../config/app-config";
import { ResetService } from "../../../reset/reset.service";
import { AmplitudeService } from 'app/utils/amplitude.service';

@Component({
  selector: 'cc-channels-reset-email',
  templateUrl: './channels-reset-email.component.html',
  styleUrls: ['./channels-reset-email.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class ChannelsResetEmailComponent implements OnInit {
  public resetForm: UntypedFormGroup;
  loading = false;
  errorTranslation = "";

  constructor(private fb: UntypedFormBuilder,
              private resetService: ResetService,
              private amplitudeService: AmplitudeService,
              private router: Router,
              private appConfig: AppConfig) { }

  ngOnInit() {
    this.amplitudeService.logEvent("SSO:Reset-Password: Init");
    this.createForm();
  }

  createForm() {
    this.resetForm = this.fb.group(({
      email: ['', Validators.compose([Validators.required, Validators.pattern(this.appConfig.emailPattern)])]
    }));
  }

  reset() {
    if (this.loading || this.resetForm.invalid) return;
    this.loading = true;
    this.errorTranslation = "";
    this.amplitudeService.logEvent("SSO:Reset-Password: Submit");
    this.resetService.email(this.resetForm.value.email.trim()).subscribe({
      next: () => {
        this.loading = false;
        this.router.navigate(['/reset', 'email', 'success']);
      },
      error: (error: unknown) => {
        this.loading = false;
        this.errorTranslation = error instanceof HttpErrorResponse && error.status === 429
          ? 'CHANNELS.RESET.TOO_MANY_REQUESTS'
          : 'CHANNELS.RESET.REQUEST_FAILED';
      }
    });
  }

  remember() {
    this.amplitudeService.logEvent("SSO:Reset-Password: Remember password, redirect to Login");
  }
}
